import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../../styles/variables.style';
import { select } from '../../styles/components/forms.style';

export const img = css`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  margin: 30px auto 0;
  border: 2px solid ${appColors.gray100};

  @media (min-width: ${breakpoints.lg.up}) {
    width: 215px;
    height: 215px;
  }

  & > img {
    width: 120px;
    height: 120px;
    object-fit: contain;
    display: block;
    margin: auto;

    @media (min-width: ${breakpoints.lg.up}) {
      width: 150px;
      height: 150px;
    }
  }
`;

const colors = [
  '#1ec0ff',
  '#87daa2',
  '#ffc853',
  '#f05c5c',
  '#9187da',
  '#da8787',
  '#87b4da',
  '#c287da',
  '#9187da',
  '#87daae',
  '#dd62ef',
];

export const title = css`
  font-size: 36px;
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  text-align: center;
  margin: 40px 0 30px;
  
  span {
    color: inherit !important;
  }
  
  background: linear-gradient(135deg, #ff7e14 0%, #e05500 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (min-width: ${breakpoints.md.up}) {
    font-size: 56px;
  }
`;

export const line = css`
  font-size: 24px;
  margin: 0 0 40px;
  text-align: center;
  font-style: italic;

  span {
    color: ${appColors.orange};
  }
`;

export const summary = css`
  width: 270px;
  border-radius: 10px;
  padding: 30px 20px 10px;
  margin: 0 auto 30px;
  border: 2px solid ${appColors.orange};
  text-align: center;

  .s-title {
    font-size: 55px;
    color: ${appColors.orange};
    font-family: ${fontFamily.fredoka};
    margin: 0;
  }

  .sub-title {
    font-family: ${fontFamily.fredoka};
    font-size: 20px;
    margin: 0;
  }

  .line {
    font-size: 14px;
    margin: 0 0 35px;

    &.no-margin {
      margin: 0;
    }
  }

  .row {
    display: flex;
    margin: 0 -6px;
  }

  .item {
    flex: 0 0 50%;
    padding: 0 6px;

    &:not(:last-child) {
      border-right: 1px solid ${appColors.gray200};
    }

    &-title {
      font-family: ${fontFamily.fredoka};
      font-size: 30px;
      color: var(--color);
      margin: 0;
    }
  }
`;

export const label = css`
  display: block;
  font-size: 24px;
  margin: 0 0 10px;
  text-align: center;
`;

export const select2 = css`
  ${select}
  max-width: 480px;
  margin: 0 auto;
`;

export const list = css`
  max-width: 800px;
  margin: 0 auto 60px;
  position: relative;
  z-index: 1;
`;

export const listItem = css`
  &:not(:last-child) {
    margin-bottom: 15px;
  }

  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  flex-direction: column;
  border: none;
  padding: 15px 20px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  text-align: left;
  color: ${appColors.gray800};
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  @media (min-width: ${breakpoints.lg.up}) {
    flex-direction: row;
    height: 90px;
    padding: 0 30px;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(241, 102, 2, 0.15);
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 6px;
    background: linear-gradient(to bottom, #ff7e14, #e05500);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover::before {
    opacity: 1;
  }

  & > .count {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f6f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #555;
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 20px;
    border: 2px solid transparent;

    @media (min-width: ${breakpoints.lg.up}) {
      margin-right: 30px;
      margin-bottom: 0;
    }
  }

  &:nth-child(1) > .count {
    background: linear-gradient(135deg, #ffd700, #ffb300);
    color: #fff;
    box-shadow: 0 4px 10px rgba(255, 215, 0, 0.4);
  }
  &:nth-child(2) > .count {
    background: linear-gradient(135deg, #e0e0e0, #9e9e9e);
    color: #fff;
    box-shadow: 0 4px 10px rgba(158, 158, 158, 0.4);
  }
  &:nth-child(3) > .count {
    background: linear-gradient(135deg, #cd7f32, #a0522d);
    color: #fff;
    box-shadow: 0 4px 10px rgba(205, 127, 50, 0.4);
  }

  & > .avatar {
    ${img}

    margin: 0;
    border-color: #eee;
    width: 50px;
    height: 50px;

    @media (min-width: ${breakpoints.md.up}) {
      margin-right: 22px;
      width: 60px;
      height: 60px;
    }
    
    img {
      width: 100%;
      height: 100%;
    }
  }

  & > .username {
    flex: 1;
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 18px;
    margin: 10px 0;

    @media (min-width: ${breakpoints.lg.up}) {
      margin: 0;
    }
  }

  & > .points {
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 18px;
    color: #e05500;
    display: flex;
    align-items: center;
    margin: 0;

    @media (min-width: ${breakpoints.lg.up}) {
      padding-left: 30px;
    }

    & > img {
      margin-right: 15px;
      width: 24px;
    }
  }
`;

export const glitter = css`
  display: none;
`;
